exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/client/client-new-planning/client-new-planning.component.css
// module id = ../../../../../src/app/_components/client/client-new-planning/client-new-planning.component.css
// module chunks = main